import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

export default function ProfilPublik() {
  const { companyId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/website-profile/public/${companyId}`)
      .then(r => setProfile(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [companyId]);

  if (loading) return <div style={s.loading}>Memuat...</div>;
  if (notFound) return (
    <div style={s.notFound}>
      <div>Profil perusahaan tidak ditemukan</div>
      <Link to="/" style={s.backLink}>← Kembali ke Beranda</Link>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.container}>
        {/* Banner */}
        <div style={s.banner}>
          {profile.foto_filename
            ? <img src={`${API}/api/website-profile/image/${profile.foto_filename}`} alt="banner" style={s.bannerImg} />
            : <div style={s.bannerBg} />}
          {profile.logo_filename && (
            <div style={s.logoWrap}>
              <img src={`${API}/api/website-profile/image/${profile.logo_filename}`} alt="logo" style={s.logo} />
            </div>
          )}
          <Link to="/" style={s.backBtn}>← Kembali</Link>
        </div>

        {/* Content */}
        <div style={s.content}>
          <h1 style={s.nama}>{profile.nama_web || 'Profil Perusahaan'}</h1>

          {profile.deskripsi && <p style={s.desc}>{profile.deskripsi}</p>}

          {profile.poin?.length > 0 && (
            <div style={s.poinSection}>
              <h3 style={s.sectionTitle}>Keunggulan Kami</h3>
              <ul style={s.poinList}>
                {profile.poin.map((p, i) => (
                  <li key={i} style={s.poinItem}>
                    <span style={s.checkIcon}>✅</span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {(profile.alamat || profile.telepon || profile.email) && (
            <div style={s.infoSection}>
              <h3 style={s.sectionTitle}>Kontak & Lokasi</h3>
              <div style={s.infoGrid}>
                {profile.alamat && (
                  <div style={s.infoCard}>
                    <span style={s.infoIcon}>📍</span>
                    <div>
                      <div style={s.infoLabel}>Alamat</div>
                      <div style={s.infoVal}>{profile.alamat}</div>
                    </div>
                  </div>
                )}
                {profile.telepon && (
                  <div style={s.infoCard}>
                    <span style={s.infoIcon}>📞</span>
                    <div>
                      <div style={s.infoLabel}>Telepon</div>
                      <a href={`tel:${profile.telepon}`} style={s.infoLink}>{profile.telepon}</a>
                    </div>
                  </div>
                )}
                {profile.email && (
                  <div style={s.infoCard}>
                    <span style={s.infoIcon}>✉️</span>
                    <div>
                      <div style={s.infoLabel}>Email</div>
                      <a href={`mailto:${profile.email}`} style={s.infoLink}>{profile.email}</a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#f5f7fa', fontFamily: "'Inter', sans-serif" },
  container: { maxWidth: '800px', margin: '0 auto', background: 'white', minHeight: '100vh', boxShadow: '0 0 40px rgba(0,0,0,0.08)' },
  loading: { display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '16px', color: '#6b7280' },
  notFound: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', gap: '16px', color: '#6b7280' },
  backLink: { color: '#1d4ed8', fontSize: '14px' },
  banner: { position: 'relative', height: '260px', background: '#1a1a2e', overflow: 'hidden' },
  bannerImg: { width: '100%', height: '100%', objectFit: 'cover' },
  bannerBg: { width: '100%', height: '100%', background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)' },
  logoWrap: { position: 'absolute', bottom: '-30px', left: '32px', background: 'white', borderRadius: '12px', padding: '6px', boxShadow: '0 4px 16px rgba(0,0,0,0.15)', width: '72px', height: '72px', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  logo: { width: '60px', height: '60px', objectFit: 'contain' },
  backBtn: { position: 'absolute', top: '16px', left: '16px', color: 'rgba(255,255,255,0.9)', textDecoration: 'none', fontSize: '14px', background: 'rgba(0,0,0,0.3)', padding: '6px 12px', borderRadius: '8px' },
  content: { padding: '48px 32px 40px' },
  nama: { fontSize: '28px', fontWeight: '800', color: '#1a1a2e', margin: '0 0 16px' },
  desc: { fontSize: '15px', color: '#4b5563', lineHeight: 1.7, marginBottom: '28px' },
  sectionTitle: { fontSize: '16px', fontWeight: '700', color: '#1a1a2e', marginBottom: '14px', margin: '0 0 14px' },
  poinSection: { marginBottom: '28px' },
  poinList: { listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' },
  poinItem: { display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '15px', color: '#374151', padding: '10px 14px', background: '#f9fafb', borderRadius: '8px' },
  checkIcon: { flexShrink: 0, fontSize: '16px' },
  infoSection: { marginTop: '8px' },
  infoGrid: { display: 'flex', flexDirection: 'column', gap: '12px' },
  infoCard: { display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '14px 18px', background: '#f9fafb', borderRadius: '10px' },
  infoIcon: { fontSize: '20px', flexShrink: 0, marginTop: '2px' },
  infoLabel: { fontSize: '12px', color: '#9ca3af', marginBottom: '2px' },
  infoVal: { fontSize: '15px', color: '#1a1a2e', fontWeight: '500' },
  infoLink: { fontSize: '15px', color: '#1d4ed8', fontWeight: '500', textDecoration: 'none' }
};
